if (!window.MenuDrawer) {
  window.MenuDrawer = class extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector("details");
      this.detailsElements = this.querySelectorAll("details");
      this.menuLinks = this.querySelectorAll(".menu-drawer__menu-item");
      this.menuDrawer = this.querySelector(".menu-drawer");

      this.bindEvents();
    }

    bindEvents() {
      this.mainDetailsToggle.addEventListener(
        "toggle",
        this.onToggleDrawer.bind(this)
      );

      this.detailsElements.forEach((details) => {
        details.addEventListener("click", this.onDetailsClick.bind(this));
        details.addEventListener("focusout", this.onFocusOut.bind(this));
        details.addEventListener("keyup", this.onKeyUp.bind(this));
      });

      this.menuLinks.forEach((link) => {
        if (!link.hasAttribute("role")) {
          link.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }
      });
    }

    onToggleDrawer() {
      if (this.mainDetailsToggle.open) {
        this.menuDrawer.classList.add("is-open");
      } else {
        this.menuDrawer.classList.remove("is-open");
      }
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;
      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;
      this.closeSubmenu(openDetailsElement);
      event.preventDefault();
    }

    onDetailsClick(event) {
      const targetElement = event.target;
      const detailsElement = event.currentTarget;
      const isSubmenuToggle = targetElement.closest("summary");

      if (
        targetElement.classList.contains("menu-drawer__menu-item") &&
        !isSubmenuToggle
      ) {
        event.stopPropagation();
        return;
      }

      if (!isSubmenuToggle) return;

      event.preventDefault();

      if (detailsElement.hasAttribute("open")) {
        this.closeSubmenu(detailsElement);
      } else {
        this.openSubmenu(detailsElement);
      }
    }

    openSubmenu(detailsElement) {
      this.detailsElements.forEach((details) => {
        if (details !== detailsElement && details.hasAttribute("open")) {
          this.closeSubmenu(details);
        }
      });

      const submenu = detailsElement.querySelector(".menu-drawer__submenu");

      if (!submenu) return;

      submenu.style.display = "block";
      detailsElement.setAttribute("open", "");

      void submenu.offsetHeight;

      requestAnimationFrame(() => {
        submenu.classList.add("is-opening");
        detailsElement.classList.add("menu-opening");

        submenu.addEventListener(
          "transitionend",
          () => {
            submenu.classList.remove("is-opening");
            submenu.classList.add("is-open");
            detailsElement.classList.remove("menu-opening");
          },
          { once: true }
        );
      });
    }

    closeSubmenu(detailsElement) {
      const submenu = detailsElement.querySelector(".menu-drawer__submenu");

      if (!submenu) return;

      submenu.classList.remove("is-open", "is-opening");
      submenu.classList.add("is-closing");

      submenu.addEventListener(
        "transitionend",
        () => {
          submenu.classList.remove("is-closing");
          submenu.style.display = "none";
          detailsElement.removeAttribute("open");
        },
        { once: true }
      );
    }

    onFocusOut(event) {
      const detailsElement = event.currentTarget;
      setTimeout(() => {
        if (!detailsElement.contains(document.activeElement)) {
          this.closeSubmenu(detailsElement);
        }
      });
    }
  };
}

if (!customElements.get("header-drawer")) {
  customElements.define("header-drawer", window.MenuDrawer);
}
